import { render, staticRenderFns } from "./stadiumvipexcel_import.vue?vue&type=template&id=ae8b4b96&"
import script from "./stadiumvipexcel_import.vue?vue&type=script&lang=ts&"
export * from "./stadiumvipexcel_import.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports